import React from 'react'

import { Spacings } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const WrapperStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  margin: `${toPx(Spacings.BLOCK_VERTICAL_SPACING)} ${toPx(Spacings.NODE_HORIZONTAL_PADDING)}`,
}

export const WrapperLastStyle: React.CSSProperties = {
  ...WrapperStyle,
  marginBottom: toPx(0),
}
